import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { updateOnOwnCompanyChange } from '../utils/personaDetailsUtils';

const OwnCompany = ({ values }) => (
  <Content>
    {({ globalRadioError = '', personDetailsOwnMoreCompany = '', radioFieldYes, radioFieldNo }) => (
      <Field name="ownCompany" subscription={{ touched: true, error: true }} validate={isRequired}>
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="ownCompany"
            title={personDetailsOwnMoreCompany}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="ownCompany"
              items={[
                {
                  id: 'Y',
                  labelText: radioFieldYes
                },
                {
                  id: 'N',
                  labelText: radioFieldNo
                }
              ]}
              {...input}
              selectedId={values.ownCompany}
              onChange={selectedId => {
                updateOnOwnCompanyChange(selectedId);
                input.onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default OwnCompany;
